/** Measurement ID do GA4 (mesmo do snippet em `index.html`). */
export const GA_MEASUREMENT_ID = 'G-3T06634HC3';

declare global {
  interface Window {
    dataLayer?: unknown[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtag?: (...args: any[]) => void;
  }
}

/**
 * page_view em navegações SPA.
 * O page_view inicial já vem do `gtag('config', …)` no `index.html`.
 */
export function trackPageView(path: string, title?: string) {
  if (import.meta.env.VITE_USE_MOCKS === 'true') return;
  if (typeof window.gtag !== 'function') return;
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: path,
    page_title: title ?? document.title,
  });
}
